import { useLoader } from "./useLoader";

interface ApiLoaderOptions {
  captureError?: boolean;
  throwError?: boolean;
  isGlobalError?: boolean;
  errorTransform?: (error: any) => Error;
  // option to use the redux loading state instead of internal loader state
  useGlobalLoadingOnly?: boolean;
}

// DEPRECATED
export const useApiLoader = () => {
  const {
    startLoading,
    stopLoading,
    isLoading,
    setError,
    clearError,
    hasError,
    getError,
    setGlobalError,
    clearGlobalError,
    globalError,
    startGlobalLoading,
    stopGlobalLoading
  } = useLoader();

  // Call with loading management
  const callWithLoading = async <T,>(
    key: string,
    apiCall: () => Promise<T>,
    options: ApiLoaderOptions = {}
  ): Promise<T | null> => {
    const {
      captureError = true,
      throwError = false,
      isGlobalError = false,
      errorTransform = (err: any) => err instanceof Error ? err : new Error(String(err)),
      useGlobalLoadingOnly = false
    } = options;

    try {
      // Clear previous errors for this key
      if (captureError) {
        if (isGlobalError) {
          clearGlobalError();
        } else {
          clearError(key);
        }
      }

      // Start loading indicators
      if (useGlobalLoadingOnly) {
        startGlobalLoading();
      } else {
        startLoading(key);
      }

      // Call the API
      const result = await apiCall();
      return result;
    } catch (error) {
      // Capture error if requested
      if (captureError) {
        const transformedError = errorTransform(error);
        if (isGlobalError) {
          setGlobalError(transformedError);
        } else {
          setError(key, transformedError);
        }
      }

      // Propagate error if requested
      if (throwError) {
        throw error;
      }
      return null;
    } finally {
      // Always stop the loading indicator
      if (useGlobalLoadingOnly) {
        stopGlobalLoading();
      } else {
        stopLoading(key);
      }
    }
  };

  return {
    callWithLoading,
    isLoading,
    hasError,
    getError,
    clearError,
    globalError,
    clearGlobalError,
    startGlobalLoading,
    stopGlobalLoading
  };
};
